 import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
//import {mydata} from './mydata.service.spec';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { AppHomePage } from '../pages/apphome/apphome';
import { LoginPage }  from '../pages/login/login';
import {SignUpPage}  from '../pages/signup/signup';
import {OtpPage}  from '../pages/otp/otp';
//import {CategoryPage}  from '../pages/category/category';
import {ProductPage}  from '../pages/product/product';
import {MycartPage}  from '../pages/mycart/mycart';
import {OrderHistoryPage}  from '../pages/orderhistory/orderhistory';
import {ReferFriendsPage}  from '../pages/referfriends/referfriends';
import {KiloPointsPage}  from '../pages/kilopoints/kilopoints';
import {AboutUsPage}  from '../pages/aboutus/aboutus';
import {KiloMenuPage}  from '../pages/kilomenu/kilomenu';
import {KiloPartyPage}  from '../pages/kiloparty/kiloparty';
import {KiloStorePage}  from '../pages/kilostore/kilostore';
import {KilopartyProductPage}  from '../pages/kilopartyproduct/kilopartyproduct';
import {OrderPlacePage}  from '../pages/orderplace/orderplace';
//import {MydataService} from './mydata.service.spec';
import {ProfilePage} from '../pages/profile/profile';
import {DeliveryPage} from '../pages/delivery/delivery';
import {PaymentPage} from '../pages/payment/payment';
import {OrderDetailPage} from '../pages/orderdetail/orderdetail';
import { AlertController } from 'ionic-angular';
import {ProductviewPage} from '../pages/productview/productview';
import {InviteFriendPage} from '../pages/invitefriend/invitefriend';
import {InfoPage}  from '../pages/info/info';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { Events } from 'ionic-angular';



@Component({
 
 templateUrl: 'app.html',
    providers: [Contacts]
	
// templateUrl: <ion-nav [root]="root page"></ion-nav>
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = HomePage;
userids:string;
	 //allContacts:Array<any>;
  pages: Array<{title: string, titleicon: string, component: any}>;

  constructor(public platform: Platform,public alerCtrl: AlertController, public statusBar: StatusBar, public splashScreen: SplashScreen,private contacts: Contacts  ,public events: Events) {
    this.initializeApp();
	this.userids=window.localStorage.getItem('userid');

	events.subscribe('user:login',() =>{
	this.refreshh();
	
	});
    // used for an example of ngFor and navigation
    this.pages = [
      {title: 'Home', titleicon: 'home', component: HomePage },
	  //{title: 'Category', titleicon: 'home', Component:'},
	  {title: 'Kilo Menu', titleicon: 'square', component: KiloMenuPage},
	  {title: 'Kilo Party', titleicon: 'square', component: KiloPartyPage},
	  {title: 'Kilo Store', titleicon: 'square', component: KiloStorePage},
	  {title: 'Kilo Cart', titleicon: 'md-cart', component: MycartPage},
	  //{title: 'Order History', titleicon: 'paper', component: OrderHistoryPage},
	  //{title: 'Refer Friends', titleicon: 'md-person-add', component: ReferFriendsPage},
	  //{title: 'Kilo Points', titleicon: 'star', component: KiloPointsPage},
	  {title: 'About Us', titleicon: 'information-circle', component: AboutUsPage},
	   //{title: 'Info', titleicon: 'information-circle', component: InfoPage},
      //{title: 'OtpPage', titleicon: 'home', component: OtpPage },
	  //{title: 'AppHome', titleicon: 'home', component: AppHomePage },
      //{title: 'SignUp', titleicon: 'home', component: SignUpPage},
	  //{title: 'Product', titleicon: 'home', component: ProductPage},
	 // {title: 'Kilo party Product', titleicon: 'home', component: KilopartyProductPage},
	  //{title: 'Profile', titleicon: 'contact', component: ProfilePage},
	  //{title: 'Login', titleicon: 'power', component: LoginPage},
		//{title:'Product View',titleicon: 'contact', component:ProductviewPage}
    ];

  }
  

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
refreshh()
{
	this.userids=window.localStorage.getItem('userid');
}
  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario

	//alert(JSON.stringify(page.title));
	this.userids=window.localStorage.getItem('userid');
		 //alert(this.userids);
	if(page.title=='Kilo Menu')
		   {			   
		  window.localStorage.setItem('localid', '1' );
		  //this.nav.push(KiloMenuPage);
		   }
		   if(page.title=='Kilo Party')
		   {			   
		  window.localStorage.setItem('localid', '2' );
		  //this.nav.push(KiloPartyPage);
		   }
		   if(page.title=='Kilo Store')
		   {			   
		  window.localStorage.setItem('localid', '3' );
		  //this.nav.push(KiloStorePage);
		   }
		   
		    if(page.title=='Profile')
		   {			   
		 var userids=window.localStorage.getItem('userid');
		
		 if(userids== null){
			 
		  //this.nav.setRoot(LoginPage);
		  this.showAlert();
		 }else{
			this.nav.setRoot(ProfilePage); 
		 }
		   }
		   
		   	 else if(page.title=='Order History')
		   {			   
		 var userids=window.localStorage.getItem('userid');
	
		 if(userids== null){
			
		  //this.nav.setRoot(LoginPage);
		  this.showAlert();
		 }else{
			this.nav.setRoot(OrderHistoryPage); 
		 }
		   }
		   
		   else{
		   
           this.nav.setRoot(page.component);
		   }
 }
      
	  
	  
	 
	 logout(){
		
		 window.localStorage.clear();
		 this.userids=window.localStorage.getItem('userid');
		 //alert(this.userids);
	this.nav.setRoot(HomePage);	
  }	
  
  login(){
		
		
		 this.userids=window.localStorage.getItem('userid');
		 //alert(this.userids);
	this.nav.setRoot(LoginPage);	
  }
  
  signup()
  {
	 this.userids=window.localStorage.getItem('userid');
	 this.nav.setRoot(SignUpPage);
  }

OrderHistory(){	
		 this.userids=window.localStorage.getItem('userid');	 
	this.nav.setRoot(OrderHistoryPage);	
  }	
ReferFriends(){	
	//this.contacts.find(['*']).then((contacts)=>{
			//this.allContacts=contacts;
//}) 
			
				//var multttias =JSON.stringify(this.allContacts)
				//console.log("contactfff"+multttias);
				//alert(multttias);
			//window.localStorage.setItem('contactt',multttias);
		 this.userids=window.localStorage.getItem('userid');

	this.nav.setRoot(ReferFriendsPage);
  }
KiloPoints(){	
	this.userids=window.localStorage.getItem('userid');	 
	this.nav.setRoot(KiloPointsPage);	
  }
profile(){	
		 this.userids=window.localStorage.getItem('userid');	 
	this.nav.setRoot(ProfilePage);	
  }  
	
	showAlert=function() {
	   
   let alert = this.alerCtrl.create({
     // title: 'New Friend!',
      subTitle: 'Please login',
      buttons: ['OK']
    });
    alert.present();
  }	
  
  
	

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts